/**
 * 商品リストセクション用カスタム要素
 * fac-component-carousel-sliderの初期化を確実に実行する
 */
if (!customElements.get('product-list-section')) {
  class ProductListSection extends HTMLElement {
    connectedCallback() {
      // カルーセルコンポーネントの初期化を確実に実行
      this.initCarousel();
    }

    initCarousel() {
      const carousel = this.querySelector('fac-component-carousel-slider');
      if (!carousel) return;

      // カスタム要素が定義されているか確認
      if (customElements.get('fac-component-carousel-slider')) {
        // すでに定義されている場合、connectedCallbackを手動実行
        if (!carousel.track) {
          carousel.connectedCallback();
        }
      } else {
        // 定義されていない場合は定義を待つ
        customElements.whenDefined('fac-component-carousel-slider').then(() => {
          if (!carousel.track) {
            carousel.connectedCallback();
          }
        });
      }
    }
  }

  customElements.define('product-list-section', ProductListSection);
}
